import { Button, styled } from '@mui/material';
import { RookeryBoldFont } from 'v3/styles/common';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const StyledOptionButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  font: `700 1rem ${RookeryBoldFont}`,
  textTransform: 'unset',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.light,
  minWidth: '7.625rem',
  borderRadius: '0.5rem',
  border: `0.063rem solid ${theme.palette.common.white}`,
  boxSizing: 'border-box',
  cursor: 'pointer',
  width: '100%',
  padding: '1rem',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const TextContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});

export const TextBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  flex: 1,
});

export const TextOpacity = styled('div')({
  opacity: '0.5',
});

export const ChevronIconStyled = styled(ChevronRightIcon)(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: '3rem',
  marginLeft: '0.5rem',
}));
